import React, { Component } from 'react'
import Typography from 'material-ui/Typography'
import Paper from 'material-ui/Paper'
import { withStyles } from 'material-ui/styles'
import styles from './styles'

class NoData extends React.Component {

  render() {

    const {
      classes,
      translate,
      noDataText,
    } = this.props

    if(noDataText){
      return (
      <div className={classes.container}>
        <Typography className={classes.content}>
          {translate ? translate(noDataText) : 'No Data Found'}
        </Typography>
      </div >
    )
    }else{
      return null
    }
  }

}


export default withStyles(styles)(NoData)



// WEBPACK FOOTER //
// ./src/components/nodata/index.js